<template>
  <div id="app">
    <NetentFrame />
  </div>
</template>

<script>
import NetentFrame from './components/NetentFrame.vue'
import NoSleep from 'nosleep.js'

const noSleep = new NoSleep()

export default {

  name: 'App',

  created () {
    noSleep.enable()
  },
  components: {
    NetentFrame
  },
  destroyed () {
    noSleep.disable()
  }
}
</script>

<style>
#app {
  text-align: center;
}
</style>
